var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhotoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_514_6078)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.14811 6.37066C4.14811 5.14336 5.14303 4.14844 6.37033 4.14844C7.59763 4.14844 8.59256 5.14336 8.59256 6.37066C8.59256 7.59796 7.59763 8.59288 6.37033 8.59288C5.14303 8.59288 4.14811 7.59796 4.14811 6.37066ZM6.37033 5.48177C5.87941 5.48177 5.48145 5.87974 5.48145 6.37066C5.48145 6.86158 5.87941 7.25955 6.37033 7.25955C6.86125 7.25955 7.25922 6.86158 7.25922 6.37066C7.25922 5.87974 6.86125 5.48177 6.37033 5.48177Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 13.097V2.74074C20 1.22707 18.7729 0 17.2593 0H2.74074C1.22707 0 0 1.22707 0 2.74074V17.2593C0 18.7729 1.22707 20 2.74074 20H17.2593C18.7729 20 20 18.7729 20 17.2593V13.1249C20.0002 13.1156 20.0002 13.1063 20 13.097ZM2.74074 1.33333C1.96345 1.33333 1.33333 1.96345 1.33333 2.74074V17.2593C1.33333 17.95 1.831 18.5246 2.48735 18.6439L13.6769 7.45438C13.9372 7.19403 14.3593 7.19403 14.6197 7.45438L18.6667 11.5013V2.74074C18.6667 1.96345 18.0366 1.33333 17.2593 1.33333H2.74074ZM18.6667 13.387L14.1483 8.86859L4.35022 18.6667H17.2593C18.0366 18.6667 18.6667 18.0366 18.6667 17.2593V13.387Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_514_6078"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoIcon);
export default __webpack_public_path__ + "static/media/photoIcon.229936eff62f239a480837ddef86b5be.svg";
export { ForwardRef as ReactComponent };